import React, { useState, useEffect } from 'react';
import { Card, CardTitle, Insight } from '../components/UI';
import { supabase } from '../supabaseClient';
const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
function useIsMobile() {
  const [m,setM]=React.useState(()=>typeof window!=='undefined'&&window.innerWidth<768);
  React.useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);
  return m;
}
export default function CoveragePlanner() {
  const isMobile = useIsMobile();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const [
        { data: queryData },
        { data: locData },
      ] = await Promise.all([
        supabase.from('sana_invocations').select('intent_country,intent_city,fallback_level').order('created_at',{ascending:false}).limit(2000),
        supabase.from('Locations').select('country,latitude').limit(10000),
      ]);
      // Count queries by country and L3 rate
      const qMap = {};
      (queryData||[]).forEach(r => {
        const c = r.intent_country||'Unknown';
        if(!qMap[c]) qMap[c]={country:c,queries:0,l3:0};
        qMap[c].queries++;
        if(r.fallback_level===3) qMap[c].l3++;
      });
      // Count locations and geocoding by country
      const lMap = {};
      (locData||[]).forEach(r => {
        const c = r.country||'Unknown';
        if(!lMap[c]) lMap[c]={locations:0,geocoded:0};
        lMap[c].locations++;
        if(r.latitude) lMap[c].geocoded++;
      });
      // Merge and score: priority = high queries + high L3 rate + low geocoded %
      const merged = Object.entries(qMap).map(([c,q]) => {
        const l = lMap[c]||{locations:0,geocoded:0};
        const geocodePct = l.locations>0?Math.round(l.geocoded/l.locations*100):0;
        const l3Rate = q.queries>0?Math.round(q.l3/q.queries*100):0;
        const priority = q.queries * (l3Rate/100) * (1-geocodePct/100);
        return { country:c, queries:q.queries, l3:q.l3, l3Rate, locations:l.locations, geocodePct, priority };
      }).filter(r=>r.queries>=2).sort((a,b)=>b.priority-a.priority);
      setData(merged);
      setLoading(false);
    })();
  }, []);
  const S = {th:{fontSize:'.65rem',color:'var(--color-text-secondary)',textTransform:'uppercase',letterSpacing:'.04em',padding:'6px 8px',textAlign:'left',borderBottom:'1px solid var(--color-border-tertiary)',fontWeight:500},td:{fontSize:'.72rem',padding:'6px 8px',borderBottom:'.5px solid var(--color-border-tertiary)',color:'var(--color-text-primary)'}};
  const bar=(p,c='#fd7e14')=><div style={{display:'flex',alignItems:'center',gap:4}}><div style={{width:40,height:4,borderRadius:2,background:'var(--color-background-tertiary)',overflow:'hidden'}}><div style={{height:'100%',width:p+'%',background:c,borderRadius:2}}/></div><span style={{fontSize:'.65rem',color:c}}>{p}%</span></div>;
  return (
    <div style={{fontFamily:F,padding:isMobile?'16px 14px 80px':'24px 28px'}}>
      <div style={{marginBottom:16}}>
        <h2 style={{fontSize:'1.1rem',fontWeight:500,margin:0,color:'var(--color-text-primary)'}}>Coverage planner</h2>
        <p style={{fontSize:'.78rem',color:'var(--color-text-secondary)',margin:'4px 0 0'}}>Countries ranked by geocoding priority: high query demand × high L3 failure rate × low geocoded coverage.</p>
      </div>
      <Insight type="info" style={{marginBottom:16}}>Priority score = queries × L3 rate × (1 − geocoded%). Higher = more impact from geocoding that country.</Insight>
      <Card>
        {loading?<div style={{padding:20,color:'var(--color-text-secondary)',fontSize:'.78rem'}}>Loading…</div>:(
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',minWidth:500}}>
              <thead><tr>
                <th style={S.th}>#</th><th style={S.th}>Country</th><th style={S.th}>Queries</th><th style={S.th}>L3 rate</th><th style={S.th}>Locations</th><th style={S.th}>Geocoded</th><th style={S.th}>Priority</th>
              </tr></thead>
              <tbody>{data.slice(0,30).map((r,i)=>(
                <tr key={r.country}>
                  <td style={{...S.td,color:'var(--color-text-secondary)'}}>{i+1}</td>
                  <td style={{...S.td,fontWeight:500}}>{r.country}</td>
                  <td style={S.td}>{r.queries}</td>
                  <td style={S.td}>{bar(r.l3Rate,'#dc3545')}</td>
                  <td style={S.td}>{r.locations.toLocaleString()}</td>
                  <td style={S.td}>{bar(r.geocodePct, r.geocodePct>=80?'#28a745':r.geocodePct>=40?'#fd7e14':'#dc3545')}</td>
                  <td style={{...S.td,fontWeight:500,color:'#314F5C'}}>{Math.round(r.priority)}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
